import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';

export class EStatementQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.ElectronicStatementQualifier';

    public static readonly NAME: string = 'eStatement';

    electronicStatement: boolean = true;

    constructor(qual?: IQualifier) {
      super(EStatementQualifier.CLASS, qual ? qual.id : null);
    }

    /* eslint-disable class-methods-use-this */
    getDescription(): string {
      return 'Receive eStatement';
    }
    /* eslint-enable class-methods-use-this */

    clone(): IQualifier {
      const clone = new EStatementQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default EStatementQualifier;
